import { ButtonGroup } from "reactstrap";
import { useFilterResultHeader } from "../../utils/useFilterResultHeader";
import { ResultsDropdown } from "./ResultsDropdown";
import type { TooltipProps } from "reactstrap";
import { SaveButton } from "./SaveButton";
import { SeasonsToggle } from "./SeasonsToggle";
import { WarningButton } from "./WarningButton";
import { ClientSettingsFilterResultsInfo } from "../../model/reference/settingsTypes";

export interface Fault {
  season: string;
  name: string;
  nonSeasonalValue: string;
  value: string;
  constraintCount: number;
}

export interface FilterResultPresetOption {
  filterResultId: number;
  infoId: number;
  optionId: number;
}

export interface FilterResultPreset {
  name: string;
  sortOrder: number;
  filterResultPresetOptions: FilterResultPresetOption[];
}

export type SeasonableInfo = ClientSettingsFilterResultsInfo & { season?: string };

interface FilterResultHeaderProps {
  faults: Fault[];
  getOverallSeason: () => string;
}

const commonTooltipProps: Pick<TooltipProps, "placement" | "container" | "modifiers"> = {
  placement: "top",
  container: "body",
  modifiers: {
    flip: { enabled: false },
    offset: { offset: "0,0" },
    preventOverflow: { boundariesElement: "viewport" },
  },
};

export const CUSTOM_SETTINGS_KEY = "customResultSettings";
const FilterResultHeader = ({ faults, getOverallSeason }: FilterResultHeaderProps) => {
  const vm = useFilterResultHeader(faults, getOverallSeason);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center px-3 pb-2">
        <ButtonGroup size="sm" className="w-100">
          <ResultsDropdown
            commonTooltipProps={commonTooltipProps}
            tooltipOpen={vm.tooltipOpen}
            toggleTooltip={vm.toggleTooltip}
            isOpen={vm.dropdownOpen}
            toggle={vm.dropdownToggle}
            selectedResult={vm.selectedResult}
            presetNames={vm.presetNames}
            onSelect={vm.handleSelectPreset}
          />
          <SaveButton
            canSave={vm.canSave}
            commonTooltipProps={commonTooltipProps}
            tooltipOpen={vm.tooltipOpen}
            toggleTooltip={vm.toggleTooltip}
            setShowOverwriteWarning={vm.setShowOverwriteWarning}
            showOverwriteWarning={vm.showOverwriteWarning}
            saveCustom={vm.saveCustom}
          />
        </ButtonGroup>

        <SeasonsToggle
          hasSeasons={vm.hasSeasons}
          getOverallSeason={vm.getOverallSeason}
          updateOverallSeason={vm.updateOverallSeason}
          commonTooltipProps={commonTooltipProps}
          tooltipOpen={vm.tooltipOpen}
          toggleTooltip={vm.toggleTooltip}
        />
        <WarningButton
          hasWarnings={vm.hasWarnings}
          canShowWarnings={vm.canShowWarnings}
          showAllWarnings={vm.showAllWarnings}
          commonTooltipProps={commonTooltipProps}
          tooltipOpen={vm.tooltipOpen}
          toggleTooltip={vm.toggleTooltip}
        />
      </div>
    </>
  );
};

export default FilterResultHeader;
